/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FilterConditionGroupDto } from './FilterConditionGroupDto';
import type { NotificationRuleMonitorSelectionDto } from './NotificationRuleMonitorSelectionDto';

export type NotificationRuleMonitorFilterSelectionDto = (NotificationRuleMonitorSelectionDto & {
    conditionGroups?: Array<FilterConditionGroupDto>;
    logicalOperator?: NotificationRuleMonitorFilterSelectionDto.logicalOperator;
} & {
    conditionGroups: Array<FilterConditionGroupDto>;
    logicalOperator: NotificationRuleMonitorFilterSelectionDto.logicalOperator;
});

export namespace NotificationRuleMonitorFilterSelectionDto {

    export enum logicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
